import { render, staticRenderFns } from "./Startups.vue?vue&type=template&id=98de1862&scoped=true"
import script from "./Startups.vue?vue&type=script&lang=js"
export * from "./Startups.vue?vue&type=script&lang=js"
import style0 from "./Startups.vue?vue&type=style&index=0&id=98de1862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98de1862",
  null
  
)

export default component.exports